import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const gestionsPiloteesEndpoint = API_ROUTE.RECUPERATION_GESTIONS_PILOTEES;

const getGestionsPilotees = async (token: string) => {
  const response = await axios.post(
    `${apiBaseUrl}${gestionsPiloteesEndpoint}`,
    {},
    {
      headers: {
        token: `${token}`,
      },
    }
  );

  if (!response) {
    throw new Error('Erreur lors de la recuperation des gestions pilotees');
  }
  const data = await response.data;
  return data;
};

const useGetGestionsPilotees = (token: string, key: string) => {
  return useQuery({
    queryKey: ['useGetGestionsPilotees', token],
    queryFn: () => getGestionsPilotees(token),
    enabled: !!token && key === 'versement',
  });
};

export { getGestionsPilotees, useGetGestionsPilotees };
